var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-conversation-answer-shape",class:_vm.className},[_c('div',{staticClass:"cloud-scale",style:({
			transform: `scale(${0.75 + _vm.ratio * 0.5})`,
		})},[_c('section',{staticClass:"clouds"},_vm._l((_vm.positionsBeforeKeys),function(value){return _c('figure',{key:value,class:value},[_c('img',{attrs:{"src":_vm.getCloudFilename(value)}})])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }